'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var styleInject = require('../../styleInject.js');

var css_248z = ".Confirmation-module_confirmationHeader__YpaKH{text-align:left}.Confirmation-module_btnContainer__tAGyu{margin:1.5rem 0}.Confirmation-module_imgContainer__cbf5-{max-width:200px;width:50%}.Confirmation-module_alternateEmailForm__ehSfM{display:flex;gap:20px;margin:15px 0;max-width:400px}";
var styles = {"confirmationHeader":"Confirmation-module_confirmationHeader__YpaKH","btnContainer":"Confirmation-module_btnContainer__tAGyu","imgContainer":"Confirmation-module_imgContainer__cbf5-","alternateEmailForm":"Confirmation-module_alternateEmailForm__ehSfM"};
styleInject["default"](css_248z, '100b6aba-8c85-44a4-9be2-2febd27aa8e3');

exports["default"] = styles;
